import { Button, FormControl, FormLabel, Input, Option, Select, Stack, Typography } from '@mui/joy';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Controller, useForm } from 'react-hook-form';

import { I18N_DE } from '@/i18n/de';
import { CreateOrganizationDto, OrganizationType } from '@/modules/api';
import { backendApiOrganizationsCreateMutation } from '@/modules/api/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/_management/administration/organisationen/hinzufuegen')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: CreateOrganizationRoute,
});

function CreateOrganizationRoute() {
  const navigate = Route.useNavigate();

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm<CreateOrganizationDto>();

  const { mutateAsync, isPending } = useMutation({
    ...backendApiOrganizationsCreateMutation(),
    onSuccess: async ({ id }) =>
      navigate({
        to: '/administration/organisationen/$organizationId',
        params: { organizationId: id },
      }),
  });

  return (
    <Stack
      gap={2}
      component="form"
      onSubmit={handleSubmit(async (submitData) => {
        if (isPending) return;

        await mutateAsync({ body: submitData });
      })}
    >
      <Typography level="h3">Organisation</Typography>

      <FormControl error={!!errors.name}>
        <FormLabel>Name</FormLabel>
        <Input variant="outlined" {...register('name', { required: true })} />
      </FormControl>

      <Controller
        name="type"
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState }) => (
          <FormControl error={!!fieldState.error}>
            <FormLabel>Typ</FormLabel>
            <Select
              variant="outlined"
              {...field}
              value={field.value || null}
              onChange={(event, value) => {
                field.onChange(value);
              }}
            >
              {Object.values(OrganizationType).map((organizationType) => (
                <Option key={organizationType} value={organizationType}>
                  {I18N_DE.OrganizationType[organizationType]}
                </Option>
              ))}
            </Select>
          </FormControl>
        )}
      />

      <Stack direction="row" justifyContent="flex-end" marginTop={4}>
        <Button type="submit" disabled={isPending} loading={isPending}>
          Speichern
        </Button>
      </Stack>
    </Stack>
  );
}
